import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';

interface Props {
  children: React.ReactNode;
}

export const BidFeatureGuard: React.FC<Props> = ({ children }) => {
  const { can } = useAuth();

  if (can('Modules::UseBid')) return <>{children}</>;

  return (
    <div className="flex-1 flex flex-col">
      <div className="flex items-start gap-3 px-6 py-4 bg-amber-50 border-b border-amber-200">
        <AlertTriangle size={18} className="text-amber-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-amber-800">Bid Response module disabled</p>
          <p className="text-xs text-amber-700 mt-0.5">
            Your organisation's Bid Response access has been removed. All data is preserved in read-only mode. Contact your administrator to restore access.
          </p>
        </div>
      </div>
      <div className="pointer-events-none opacity-60 flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  );
};
